module.exports = __webpack_public_path__ + "media/images/pay4-color-ae46fd2287ecfcd6022d4f3c0854101c.svg";